import { useState } from "react";
import { Grid } from "@mui/material";
import CommonTable from "../common/CommonTable";
import { downloadWithURL } from "../../helper/ExportHelper";
import { InfoApi } from "../../api/InfoApi";
import tableConfig from "./PickleballDrillDataTableConfig";
import PickleballDrillQueryForm from "./PickleballDrillQueryForm";
import buildPickleballDrillFilters from "./buildPickleballDrillFilters";

export default function PickleballDrillDataTable() {
    const [filterQuery, setFilterQuery] = useState(false);

    const onQuery = (inputData) => {
        setFilterQuery(buildPickleballDrillFilters(inputData));
    };

    const onExport = async (inputData) => {
        const filters = buildPickleballDrillFilters(inputData);
        const result = await InfoApi.exportMemberSkillData(filters, {
            type: "pickleball_drill",
            pageSize: -1,
        });
        if (!result) {
            return;
        }
        downloadWithURL(result.export_url, result.export_filename);
    };

    return (
        <Grid>
            <Grid item xs={12}>
                <PickleballDrillQueryForm onQuery={onQuery} onExport={onExport} />
            </Grid>
            <Grid item xs={12}>
                <CommonTable
                    filterQuery={filterQuery}
                    tableConfig={tableConfig}
                    debug={false}
                    options={{ pageSize: 25 }}
                />
            </Grid>
        </Grid>
    );
}
